import { jsx as _jsx } from "react/jsx-runtime";
import { useChartData } from '../../context/ChartContext';
import { LinearVerticalAxis } from '../../elements/linearAxis/LinearVerticalAxis';
import { useJGraph } from './JGraphContext';
export function JGraphVerticalAxis() {
    const { width, margin } = useChartData();
    const { height, scaleY } = useJGraph();
    if (!scaleY)
        return null;
    return (_jsx("svg", { style: { overflow: 'visible' }, height: height + 20, width: 60, children: _jsx(LinearVerticalAxis, { x: 20, y: 0, scale: scaleY, height: height, showGrid: true, width: width - margin.right }) }));
}
